// Contact form validation
var contactForm = document.querySelector("#contact_form");
var allInputs = contactForm.querySelectorAll('input,textarea');
if (contactForm != null) {
	contactForm.addEventListener(
		"invalid",
		(function () {
			return function (e) {
				e.preventDefault();
				myValidation(e.target);
			};
		})(),
		true
	);
  if(allInputs != null){
    allInputs.forEach((ele) => {
      ele.addEventListener("input", (e) => {
        e.target.parentNode.querySelector(".form-field-error")
          ? (e.target.parentNode.querySelector(".form-field-error").innerText =
              "")
          : null;
      });
      ele.addEventListener("change", (e) => {
        e.target.parentNode.querySelector(".form-field-error")
          ? (e.target.parentNode.querySelector(".form-field-error").innerText =
              "")
          : null;
      });
    });
  }
	function myValidation(ele) {
		var errorLabel = ele.dataset.errorLabel;
		if (ele.value == "") {
			ele.parentNode.querySelector(
				".form-field-error"
			).innerText = `${errorLabel} is required`;
		} else if (ele.validity) {
			ele.parentNode.querySelector(
				".form-field-error"
			).innerText = `You have to enter a valid ${errorLabel}`;
		}
	}
}